import api from '../../../lib/api';
import type { ColumnMapping, ImportPreview, ImportResult } from '../types';

export const leadImportApi = {
  uploadFile: (formData: FormData, organizationId: string) =>
    api.post<ImportPreview>('/leads/import/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { organizationId },
    }),

  executeImport: (data: {
    organizationId: string;
    funnelTemplateId: string;
    assignedTo?: string;
    mappings: ColumnMapping[];
    file: FormData;
  }) => {
    const formData = data.file;
    formData.append('organizationId', data.organizationId);
    formData.append('funnelTemplateId', data.funnelTemplateId);
    if (data.assignedTo) formData.append('assignedTo', data.assignedTo);
    formData.append('mappings', JSON.stringify(data.mappings));
    return api.post<ImportResult>('/leads/import/execute', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { organizationId: data.organizationId },
    });
  },

  downloadTemplate: (format: 'csv' | 'xlsx' = 'csv') =>
    api.get<Blob>(`/leads/import/template`, {
      params: { format },
      responseType: 'blob',
    }),
};
